/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Checkbox-with-check stroke icon (14×14). Color via `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const CheckSquareIcon = ({
  size = 14,
  strokeWidth = 1.28333,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M5.25 6.41658L7 8.16658L12.8333 2.33325"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M12.25 7V11.0833C12.25 11.7272 11.7272 12.25 11.0833 12.25H2.91667C2.27277 12.25 1.75 11.7272 1.75 11.0833V2.91667C1.75 2.27277 2.27277 1.75 2.91667 1.75H9.33333"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

CheckSquareIcon.propTypes = {
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default CheckSquareIcon;
